/**
 * Created by olga on 10.07.2025
 */

Placements.ENTRIES["renovationWindow"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 1001,
    filter: function () {
        return cleverapps.meta.getSelectedLocation().getMigratedStars();
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "RenovationWindow",
            action: function (f) {
                new RenovationWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};
